import React, { useState } from 'react';
import AIChatModels from './components/AIChatModels/AIChatModels';
import AIChatRoom from './components/AIChatRoom/AIChatRoom';
import styles from './EyRnAI.module.scss';

export default function EyRnAI() {
    const [isOnRoom , setRoom ] = useState(false);
    
    const selectedRoom = (room : any) => {
        console.log(room);
        setRoom(true);
    }


  return (
    <div className={styles.eyRnAi}>
      {isOnRoom && (
        <button
          className="btn btn-flat text-white mb-3 text-5c pa-0"
          onClick={() => setRoom(false)}
        >
          <i className="icon-arrow-left"></i>
        </button>
      )}

      <div className={styles.eyRnAiContainer}>
        {isOnRoom ? (
          <AIChatRoom />
        ) : (
          <AIChatModels selectedRoom={selectedRoom} />
        )}
      </div>

      <div className={styles.eyRnAiForm}>
        <i className="icon-mic"></i>
        <input type="text" placeholder="What can I help you with?" />
        <button className="icon-arrow-right"></button>
      </div>
    </div>
  );
}
